import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, A11y, FreeMode, Controller } from 'swiper/modules';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';
import audioPlayer from '@blocks/audio_player/AudioPlayer';
import dataLayerPushSlider from '@utils/dataLayerPushSlider';

function init() {
  if (!$('[data-au-testimonials]')) return;

  buildSlider();
}

function buildSlider() {
  $$('[data-au-testimonials-slider]').forEach((slider) => {
    const container = slider.closest('[data-au-testimonials]');
    const pagination = container.querySelector('[data-au-testimonials-pagination]');

    const mainSlider = new Swiper(slider, {
      modules: [A11y, Controller],
      ...sliderConfig,
      spaceBetween: 32,
      slideToClickedSlide: true,
      pagination: {
        el: 'data-au-testimonials-pagination',
      },
      on: {
        slideChange: (swiper) => {
          const testimonialsRoot = swiper.el.closest('[data-au-testimonials]');
          audioPlayer.resetWithin(testimonialsRoot);
          setActive(swiper);
        },
        slideChangeTransitionEnd: (e) => {
          dataLayerOnChangeSlideMainSlider(e);
        },
        touchEnd(swiper, event) {
          dataLayerPushSlider(swiper, event);
        },
      },
      breakpoints: {
        768: {
          spaceBetween: 80,
          freeMode: false,
          slidesOffsetAfter: container.offsetWidth - 782,
        },
      },
    });

    if (pagination) {
      const pagButton = container.querySelectorAll('[data-au-testimonials-pag-button]');
      const slidesLength = pagButton.length;

      const paginationSlider = new Swiper(pagination, {
        modules: [Navigation, A11y, FreeMode, Controller],
        ...sliderConfig,
        navigation: {
          prevEl: container.querySelector('[data-au-slider-prev]'),
          nextEl: container.querySelector('[data-au-slider-next]'),
        },
        breakpoints: {
          768: {
            slidesOffsetBefore: slidesLength > 5 && 48,
            slidesOffsetAfter: slidesLength > 5 && 48,
          },
        },
        on: {
          slideNextTransitionStart: dataLayerOnChangeSlidePaginationSliderNext,
          slidePrevTransitionStart: dataLayerOnChangeSlidePaginationSliderPrev,
          touchEnd(swiper, event) {
            dataLayerPushSlider(swiper, event);
          },
        },
      });

      pagButton.forEach((button, i) => {
        button.addEventListener('click', () => {
          mainSlider.slideTo(i);
          paginationSlider.slideTo(i);
        });
      });

      mainSlider.controller.control = paginationSlider;
    }
  });
}

function setActive(e) {
  const pagBullets = e.el.closest('[data-au-testimonials]').querySelectorAll('[data-au-testimonials-pag-button]');

  pagBullets.forEach((sibling) => {
    sibling.classList.remove('au-testimonials__bullet--active');
  });

  pagBullets[e.activeIndex].classList.add('au-testimonials__bullet--active');
}

function dataLayerOnChangeSlideMainSlider(e) {
  e.el
    .closest('[data-au-testimonials-slider]')
    .querySelectorAll('.swiper-slide-active')
    .forEach((el) => {
      let titleText = el.closest('section').querySelector('[data-au-heading-title]').innerText,
        clickText = el.querySelector('[data-au-title]').innerText;

      titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
      clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

      const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSlider',
        item_id,
      });
    });
}

function dataLayerOnChangeSlidePaginationSliderNext(e) {
  let titleText = e.el.closest('section').querySelector('[data-au-heading-title]').innerText;
  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

  let clickText = e.navigation.nextEl.querySelector('[data-au-hidden-label]').innerText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

function dataLayerOnChangeSlidePaginationSliderPrev(e) {
  let titleText = e.el.closest('section').querySelector('[data-au-heading-title]').innerText;
  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

  let clickText = e.navigation.prevEl.querySelector('[data-au-hidden-label]').innerText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

export default { init };
